import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { ConfirmDialog } from "primereact/confirmdialog";
import HistoricoModal from "./HistoricoModal.jsx";
//import ResumenEstadosPedidos from "../Componentes/ResumenEstadoPedidos.jsx";
import { Formatofecha } from "../Componentes/Formatofecha.jsx";
import { Traductor } from "../Componentes/Traductor.js";
import BotonesHistorico from "../Componentes/BotonesHistorico.jsx";
//import EstadoPedidoCell from "../Componentes/EstadoPedidosCell.jsx";
import { fetchWithAuth, API_URL } from "../Componentes/fetchWithAuth.js";

//import "../styles/App.css";
import "../styles/Historico.css";

//const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const Historico = ({ language }) => {
  const [listaPedidos, setListaPedidos] = useState([]);
  const [filteredListaPedidos, setFilteredListaPedidos] = useState([]);
  const [searchText, setSearchText] = useState("");
  //const [selectedPedido, setSelectedPedido] = useState(null); // Pedido seleccionado para edición
  const [selectedPedidoId, setSelectedPedidoId] = useState(null);
  const [isHistoricoModalOpen, setHistoricoModalOpen] =
    useState(false); /* Nuevo estado para el modal de histórico */
  const [contenedoresPorPedido, setContenedoresPorPedido] = useState({});

  const toastCenter = useRef(null);

  const translations = useMemo(() => Traductor(language), [language]);

  const renderContenedores = useCallback(
    (rowData) => {
      const ids = contenedoresPorPedido[rowData.idpedido] || [];

      if (ids.length === 0) return null;

      const visibles = ids.slice(0, 2).join(", ");
      const ocultos = ids.length > 2 ? "..." : "";
      const tooltipText = ids.join(", ");

      return (
        <span title={tooltipText}>
          {visibles} {ocultos}
        </span>
      );
    },
    [contenedoresPorPedido],
  );

  const { columnsHistorico } = translations;

  /*
    useEffect(() => {
        fetch(`${API_URL}/listapedidos`)
            .then((response) => response.json())
            .then((data) => {
                setListaPedidos(data);
                setFilteredListaPedidos(data);
            })
            .catch((err) => console.error(translations.erroralcargarpedido, err));
    }, []);
    */

  useEffect(() => {
    const fetchPedidos = async () => {
      try {
        const pedidosRes = await fetchWithAuth(`${API_URL}/api/listahistorico`);
        const pedidosData = await pedidosRes.json();

        setListaPedidos(pedidosData);
        setFilteredListaPedidos(pedidosData);

        const mapa = {};
        pedidosData.forEach((pedido) => {
          mapa[pedido.idpedido] = pedido.contenedores || [];
        });
        setContenedoresPorPedido(mapa);
      } catch (err) {
        console.error(translations.erroralcargarpedido, err);
      }
    };

    fetchPedidos();
  }, [translations]);

  /***********Uso de toast************************************** */
  const showMessage = useCallback((severity, summary, detail) => {
    if (toastCenter.current) {
      toastCenter.current.show({ severity, summary, detail, life: 3000 });
    }
  }, []);

  const selectedPedido = useMemo(() => {
    return listaPedidos.find((p) => p.idpedido === selectedPedidoId) || null;
  }, [selectedPedidoId, listaPedidos]);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    setFilteredListaPedidos(
      listaPedidos.filter(
        (pedido) =>
          (pedido.sNombreEstadoPedido &&
            pedido.sNombreEstadoPedido.toLowerCase().includes(value)) ||
          (pedido.sNombreCliente &&
            pedido.sNombreCliente.toLowerCase().includes(value)) ||
          (pedido.sMarca && pedido.sMarca.toLowerCase().includes(value)) || // Se agrega sMarca
          (pedido.descripcion_mercancia &&
            pedido.descripcion_mercancia.toLowerCase().includes(value)) ||
          (pedido.idpedido && pedido.idpedido.toString().includes(value)) ||
          (pedido.destino && pedido.destino.toLowerCase().includes(value)),
      ),
    );
  };

  //Esta función realiza una solicitud fetch para obtener los datos actualizados desde el servidor y actualizar el estado de listaPedidos y filteredListaPedidos
  /*   const cargarPedidos = useCallback(() => {
    fetchWithAuth(`${API_URL}/api/listapedidos`)
      .then((response) => response.json())
      .then((data) => {
        setListaPedidos(data); // Actualiza la lista completa
        setFilteredListaPedidos(data); // Actualiza la lista filtrada
      })
      .catch((err) => console.error("Error al cargar listapedidos", err));
  }, []); // Dependencias vacías para que la función sea estable */

  /* const cambiarEstadoPedido = useCallback(
    async (idpedido) => {
      try {
        // Construir la URL con el parámetro idpedido
        const response = await fetchWithAuth(`${API_URL}/api/cambiar-estado-pedido/${idpedido}`, {
          method: "PUT",
        });

        // Analizar la respuesta JSON
        const data = await response.json();

        if (data.codigo === 0) {
          showMessage("success", translations.text_Confirmacion, translations.actualizacion_exitosa);
          cargarPedidos(); // Recarga la tabla de pedidos
        } else {
          showMessage("error", translations.erroralactualizar, `${translations.erroralactualizar} : ${data.mensaje}`);
        }
      } catch (err) {
        showMessage("error", translations.title_error, `${translations.erroralactualizar} : ${err.message}`);
      }
    },
    [showMessage, translations, cargarPedidos]
  ); */

  /* const EliminarLEDelPedido = useCallback(
    async (idpedido) => {
      try {
        const response = await fetchWithAuth(`${API_URL}/api/eliminar-le-pedido/${idpedido}`, {
          method: "PUT",
        });
        const data = await response.json();
        if (data.codigo === 0) {
          showMessage("success", translations.listadeempaque_eliminada, translations.eliminar_le);
          cargarPedidos(); // Recarga la tabla de pedidos
        } else {
          showMessage("error", translations.error_eliminar_le, `${translations.error_eliminar_le}: ${data.mensaje}`);
        }
      } catch (err) {
        showMessage("error", translations.title_error, `${translations.error_eliminar_le}: ${err.message}`);
      }
    },
    [showMessage, translations, cargarPedidos]
  ); */

  /* const EliminarPedido = async (idpedido) => {
    try {
      const response = await fetchWithAuth(`${API_URL}/api/eliminar-pedido/${idpedido}`, {
        method: "PUT",
      });
      const data = await response.json();
      if (data.codigo === 0) {
        showMessage("success", translations.text_Confirmacion, translations.pedidoeliminado);
        cargarPedidos(); // Recarga la tabla de pedidos
      } else {
        showMessage("error", translations.title_error, `${translations.error_eliminar_pedido}: ${data.mensaje}`);
      }
    } catch (err) {
      showMessage("error", translations.title_error, `${translations.error_eliminar_pedido}: ${err.message}`);
    }
  }; */

  /* const AnularPedido = async (idpedido) => {
    try {
      const response = await fetchWithAuth(`${API_URL}/api/anular-pedido/${idpedido}`, {
        method: "PUT",
      });
      const data = await response.json();
      if (data.codigo === 0) {
        showMessage("success", translations.text_Confirmacion, translations.pedidoanulado);
        cargarPedidos(); // Recarga la tabla de pedidos
      } else {
        showMessage("error", translations.title_error, `${translations.error_anular_pedido}: ${data.mensaje}`);
      }
    } catch (err) {
      showMessage("error", translations.title_error, `${translations.error_anular_pedido}: ${err.message}`);
    }
  }; */

  //Esta función se utiliza antes de abrir el modal de edición
  /* const handleEditPedido = () => {
    // Validar si el estado del pedido permite editar
    if (selectedPedidoId && ["CREADO", "LE_OK", "LE_APROBADA"].includes(selectedPedido.sNombreEstadoPedido)) {
      setEditModalOpen(true); // Abre el modal si el estado lo permite
    } else {
      showMessage("error", translations.title_error, translations.errorEditPedido);
    }
  }; */

  //Esta función se utiliza cuando el usuario hace clic en el botón "Guardar" en el modal
  /* const handleUpdatePedido = (updatedPedido) => {
    fetchWithAuth(`${API_URL}/api/pedidos/${updatedPedido.idpedido}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedPedido),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((error) => {
            showMessage("error", translations.title_error, translations.erroralactualizar);
            throw new Error(translations.erroralactualizar);
          });
        }
        return response.json();
      })
      .then((data) => {
        // Actualiza la lista de pedidos
        setListaPedidos((prevPedidos) => prevPedidos.map((pedido) => (pedido.idpedido === updatedPedido.idpedido ? updatedPedido : pedido)));
        setEditModalOpen(false); // Cierra el modal
        cargarPedidos();
        showMessage("success", translations.text_Confirmacion, translations.actualizacion_exitosa);
      })
      .catch((err) => {
        showMessage("error", translations.erroralactualizar, err.message);
      });
  }; */

  /* const EditarListaDeEmpaque = (updatedEmpaque) => {
    fetchWithAuth(`${API_URL}/api/editar-lista-empaque`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ idpedido: updatedEmpaque.idpedido, data: updatedEmpaque }), // Enviar el ID del pedido y los datos editados
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((error) => {
            showMessage("error", translations.erroralactualizar, translations.le_noactualizada);
            throw new Error(translations.erroralactualizar);
          });
        }
        return response.json();
      })
      .then((data) => {
        showMessage("success", translations.actualizacion_exitosa, translations.le_actualizada);
        cargarPedidos(); // Recargar la lista de pedidos si es necesario
        setEditEmpaqueModalOpen(false); // Cerrar el modal después de actualizar
      })
      .catch((err) => {
        showMessage("error", translations.erroralactualizar, err.message);
      });
  }; */

  /*   const handleCargar = useCallback((pedido) => {
    //setSelectedPedido(pedido);
    setSelectedPedidoId(pedido.idpedido);
    setUploadModalOpen(true);
  }, []); */

  const handleVer = useCallback((pedido) => {
    setSelectedPedidoId(pedido.idpedido);
    setHistoricoModalOpen(true); /* Abre el modal de histórico */
  }, []);

  /*   const handleAprobar = useCallback(
    (pedido) => {
      cambiarEstadoPedido(pedido.idpedido);
    },
    [cambiarEstadoPedido]
  );

  const handleEliminarLE = useCallback(
    (idpedido) => {
      EliminarLEDelPedido(idpedido);
    },
    [EliminarLEDelPedido]
  ); */

  /*   const renderBotonesLE = useCallback(
    (rowData) => {
      const isSelected = rowData.idpedido === selectedPedidoId;
      if (!isSelected) return null;

      console.log("Render fila LE_Button:", rowData.idpedido);

      return (
         <BotonesLE
          rowData={rowData}
          translations={translations}
          showMessage={showMessage}
          onAprobar={handleAprobar}
          onCargar={handleCargar}
          onVer={handleVer}
          onEliminar={(pedido) => handleEliminarLE(pedido.idpedido)}
        /> 
      );
    },
    [translations, showMessage, handleAprobar, handleCargar, handleVer, handleEliminarLE, selectedPedidoId]
  ); */

  const renderBotonesLE = useCallback(
    (rowData) => {
      const isSelected = rowData.idpedido === selectedPedidoId;
      if (!isSelected) return null;

      const result = (
        <BotonesHistorico
          rowData={rowData}
          translations={translations}
          showMessage={showMessage}
          //onAprobar={handleAprobar}
          //onCargar={handleCargar}
          onVer={handleVer}
          //onEliminar={(pedido) => handleEliminarLE(pedido.idpedido)}
        />
      );

      return result;
    },
    [translations, showMessage, handleVer, selectedPedidoId],
  );

  const columnElements = useMemo(() => {
    const cols = columnsHistorico.map((col, index) => (
      <Column
        key={index}
        field={col.field}
        header={col.header}
        body={(rowData) => {
          let content = rowData[col.field];

          if (["fecha_pedido", "fecha_llegada_a_bodega"].includes(col.field)) {
            const date = rowData[col.field];
            content = date ? Formatofecha(date) : "";
          } else if (["peso_bruto", "dMetrosCubicos"].includes(col.field)) {
            const value = parseFloat(rowData[col.field]);
            content = isNaN(value) ? "" : value.toFixed(2);
          }

          return (
            <span id={`historico-celda-${rowData.idpedido}-${col.field}`}>
              {content}
            </span>
          );
        }}
        sortable
      />
    ));

    // Añadir columnas Ctn y Acciones de forma estable
    cols.push(
      <Column
        key="ctn"
        header="Ctn"
        body={renderContenedores}
        exportable={false}
      />,
    );
    cols.push(
      <Column
        key="actions"
        header={translations.LE_Button}
        exportable={false}
        body={renderBotonesLE}
      />,
    );

    return cols;
  }, [columnsHistorico, translations, renderContenedores, renderBotonesLE]);

  return (
    <>
      <Toast ref={toastCenter} position="top-center" baseZIndex={9999} />
      <ConfirmDialog />
      <div className="contenedorprincipal pagina-historico">
        <h1 className="titulo">{translations.HistoricoPedidos}</h1>
        <div className="botonessuperiores">
          {/* Botones superiores omitidos para brevedad */}
        </div>

        {isHistoricoModalOpen && selectedPedido && (
          <HistoricoModal
            isOpen={isHistoricoModalOpen}
            pedido={selectedPedido}
            language={language}
            onClose={() => setHistoricoModalOpen(false)}
          />
        )}

        <div style={{ marginBottom: "2px", textAlign: "center" }}>
          <input
            id="filtro-historico-search"
            type="text"
            placeholder={translations.searchPlaceholder}
            value={searchText}
            onChange={handleSearch}
            style={{ padding: "5px", width: "200px" }}
          />
        </div>

        <DataTable
          value={filteredListaPedidos}
          paginator
          rows={15}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} pedidos"
          responsiveLayout="scroll"
          selectionMode="single"
          selection={selectedPedidoId}
          dataKey="idpedido"
          onSelectionChange={(e) => setSelectedPedidoId(e.value?.idpedido)}
          rowClassName={(rowData) => {
            return rowData.idpedido === selectedPedidoId
              ? "fila-seleccionada"
              : "";
          }}
        >
          {columnElements}
        </DataTable>
      </div>
    </>
  );
};

export default Historico;
